import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PurchaseOrderDetailsCard } from "../PurchaseOrderDetailsCard/PurchaseOrderDetailsCard";
import styles from "./purchaseOrderDetails.module.css";
import { ModalComp } from "../Modal/ModalComp";
import { PurchaseOrderTable } from "../PurchaseOrderTable/PurchaseOrderTable";
import { PurchaseOrderScopeOfWork } from "../PurchaseOrderScopeOfWork/PurchaseOrderScopeOfWork";
import { TermsConditionPO } from "../TermsConditionPO/TermsConditionPO";
import { Button } from "evergreen-ui";
import { IMAGE_PATH } from "../../../Utils/variables";
export const PurchaseOrderDetails = ({
  detailId = "",
  communityId = "",
  getFilterData,
}) => {
  const navigate = useNavigate();
  const [disablebtn, setDisableBtn] = useState(false);
  const [open, setOpen] = useState(false);
  const [total, setTotal] = useState(0);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const handleDisablebtn = () => setDisableBtn(true);
  const [detail, setDetail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    if (detailId && communityId) {
      fetch(process.env.REACT_APP_API_URL + "/api/vendorpo/poDetailsByPoID", {
        method: "POST",
        body: JSON.stringify({ po_id: detailId, community_id: communityId }),
        headers: { "content-type": "application/json" },
      })
        .then((response) => response.json())
        .then((result) => {
          setDetail(result.response.data);
          const arr = result?.response.data.po_items;
          const sum = arr.reduce((accumulator, e) => {
            return accumulator + parseFloat(e.amount);
          }, 0);
          setTotal(sum);
          const allZero = arr.every((item) => item.remain_qty == "0");
          if (allZero) {
            setErrorMessage(
              "Maximum quantity limit reached. Please reduce item quantities before creating a bill from this PO"
            );
            setDisableBtn(true);
          } else {
            setDisableBtn(false);
            setErrorMessage("");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setDetail("");
    }
  }, [detailId, communityId]);
  return (
    <div>
      <div className={detail && styles.topDivPODetails}>
        <span>
          <h1>{detail && detail?.title?.toUpperCase()}</h1>
          <p>{detail && detail?.name}</p>
        </span>
        {detail && (
          <>
            <Button
              className="poppinFont"
              disabled={disablebtn}
              onClick={() => {
                navigate("/createbill", {
                  state: {
                    hide: true,
                    poNumber: detailId,
                    commId: communityId,
                  },
                });
              }}
            >
              {disablebtn ? "Submitted" : "Submit Bill"}
            </Button>
          </>
        )}
      </div>
      <ModalComp
        open={open}
        onOpenModal={onOpenModal}
        onCloseModal={onCloseModal}
        handleDisablebtn={handleDisablebtn}
        detail={detail}
      />
      <div className={styles.middleDivPODetails}>
        {detail ? (
          <>
            <PurchaseOrderDetailsCard {...detail} />
            <PurchaseOrderTable tableData={detail?.po_items} total={total} />
            <PurchaseOrderScopeOfWork {...detail} />
            <TermsConditionPO {...detail} />
          </>
        ) : (
          <div className="noDataToShow">
            {<img src={IMAGE_PATH + "poDetails.svg"} alt="" />}
          </div>
        )}
      </div>
    </div>
  );
};
